import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/social/whatsapp-2.svg")